/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BrowseGenerated } from '../models/browse-generated';
import { NotificationLogGenerated } from '../models/notification-log-generated';

@Injectable({
  providedIn: 'root',
})
export class NotificationLogServiceGenerated extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation postNotificationLogBrowse
   */
  static readonly PostNotificationLogBrowsePath = '/notification-log/browse';

  /**
   * Browse notification log.
   *
   * Browse notification log
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postNotificationLogBrowse()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNotificationLogBrowse$Response(params?: {
    context?: HttpContext
    body?: BrowseGenerated
  }
): Observable<StrictHttpResponse<Array<NotificationLogGenerated>>> {

    const rb = new RequestBuilder(this.rootUrl, NotificationLogServiceGenerated.PostNotificationLogBrowsePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<NotificationLogGenerated>>;
      })
    );
  }

  /**
   * Browse notification log.
   *
   * Browse notification log
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `postNotificationLogBrowse$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNotificationLogBrowse(params?: {
    context?: HttpContext
    body?: BrowseGenerated
  }
): Observable<Array<NotificationLogGenerated>> {

    return this.postNotificationLogBrowse$Response(params).pipe(
      map((r: StrictHttpResponse<Array<NotificationLogGenerated>>) => r.body as Array<NotificationLogGenerated>)
    );
  }

}
